import React from "react";

const Interview = () => {
	return (
		<section className="page__interview interview">
			<h2 className="interview__title">Question/Answer</h2>

			<ul className="interview__list">
				<li className="interview__item">
					<p className="interview__item-text">Can the child work by himself?</p>
					<button type="button" className="interview__item-button">
						<img src="./img/interview/plus.svg" alt="plus" />
					</button>
				</li>
				<li className="interview__item">
					<p className="interview__item-text">How is payment made?</p>
					<button type="button" className="interview__item-button">
						<img src="./img/interview/plus.svg" alt="plus" />
					</button>
				</li>
				<li className="interview__item">
					<p className="interview__item-text">
						Are there any guarantees of assimilation of the material?
					</p>
					<button type="button" className="interview__item-button">
						<img src="./img/interview/plus.svg" alt="plus" />
					</button>
				</li>
				<li className="interview__item">
					<p className="interview__item-text">
						Who will my child interact with?
					</p>
					<button type="button" className="interview__item-button">
						<img src="./img/interview/plus.svg" alt="plus" />
					</button>
				</li>
				<li className="interview__item">
					<p className="interview__item-text">
						What are the principles of teaching?
					</p>
					<button type="button" className="interview__item-button">
						<img src="./img/interview/plus.svg" alt="plus" />
					</button>
				</li>
				<li className="interview__item">
					<p className="interview__item-text">
						How many times a week can you practice?
					</p>
					<button type="button" className="interview__item-button">
						<img src="./img/interview/plus.svg" alt="plus" />
					</button>
				</li>
			</ul>
		</section>
	);
};

export default Interview;
